module.exports = __webpack_public_path__ + "img/BoD_09_Dr_Lee_Tung_Jean.112d1239.jpg";